import React from 'react';
import { ENVIRONMENT } from '../api/config';
export default function LocalEnvironmentBadge({ className = '' }: { className?: string }) {
  if (!ENVIRONMENT?.isLocal) return null;
  return <span className={`${className} rounded px-2 py-1 text-xs font-medium ${ENVIRONMENT.isProduction ? 'bg-amber-100 text-amber-900' : 'bg-gray-100 text-gray-700'}`}>
    {ENVIRONMENT.isProduction ? 'Production data' : 'Development data'}
  </span>;
}
